import Vue from 'vue';
import VueRouter from 'vue-router';
Vue.use(VueRouter);

const routes =[
    {
        path:'/',
        redirect:'/inviteHomePage.html'
    },
    // 邀请有礼
    {
        path: '/inviteHomePage.html',
        name: 'inviteHomePage',
        component: () => import('@/pages/thematic-framework/InviteHomePage/index.vue')
    },
    {
        // 添加邀请我的人
        path: '/addInvitedMe.html',
        name: 'addInvitedMe',
        component: () => import('@/pages/thematic-framework/InviteHomePage/addInvitedMe.vue'),
        meta: {
            title: '零跑汽车'
        }
    },
    {
        // 转介绍邀请明细页面
        path: '/invitationDetails.html',
        name: 'invitationDetails',
        component: () => import('@/pages/thematic-framework/InvitationDetails/index.vue')
    },
    {
        // 被邀请用户成功页面
        path: '/invitedSuccess.html',
        name: 'invitedSuccess',
        component: () => import('@/pages/thematic-framework/InvitedSuccess/index.vue'),
        meta: {
            title: '零跑'
        }
    },
    {
    // 邀请海报列表页面
        path: '/inviteReportList.html',
        name: 'inviteReportList',
        component: () => import('@/pages/thematic-framework/InviteReport/list.vue')
    },
    {
        // 邀请海报列表页面
        path: '/inviteReportHorizontal.html',
        name: 'inviteReportHorizontal',
        component: () => import('@/pages/thematic-framework/InviteReport/index.vue')
    },
    {
    // 海报专辑页面
        path: '/inviteReportAlbum.html',
        name: 'inviteReportAlbum',
        component: () => import('@/pages/thematic-framework/InviteReport/album.vue')
    },
    {
        // 海报制作
        path: '/posterRroduction.html',
        name: 'posterRroduction',
        component: () => import('@/pages/thematic-framework/posterRroduction/index.vue'),
        meta: {
            title: '零跑汽车'
        }
    },
    {
        // 审核列表 (海报审核)
        path: '/posterReview.html',
        name: 'posterReview',
        component: () => import('@/pages/thematic-framework/posterRroduction/posterReview.vue'),
        meta: {
            title: '零跑汽车'
        }
    },
    {
        // 海报预览
        path: '/posterPreview.html',
        name: 'posterPreview',
        component: () => import('@/pages/thematic-framework/posterRroduction/posterPreview.vue'),
        meta: {
            title: '零跑汽车'
        }
    },
    {
        // 上传失败
        path: '/posterRroductionUploadFailed.html',
        name: 'posterRroductionUploadFailed',
        component: () => import('@/pages/thematic-framework/posterRroduction/posterRroductionUploadFailed.vue'),
        meta: {
            title: '零跑汽车'
        }
    },
    {
    // 图集分享页面
        path: '/inviteReportShare.html',
        name: 'inviteReportShare',
        component: () => import('@/pages/thematic-framework/InviteReport/share.vue')
    },
    {
        // 123
        path: '/InviteQrcode.html',
        name: 'InviteQrcode',
        component: () => import('@/pages/thematic-framework/InviteQrcode/index.vue')
    },
    {
        path: '*',
        name: 'NotFound',
        component: () => import('@/components/404.vue'),
        meta: {
            title: '零跑汽车'
        }
    },
    {
        // 转介绍活动日
        path: '/InviteActivityDay.html',
        name: 'InviteActivityDay',
        component: () => import('@/pages/thematic-framework/InviteActivityDay/index.vue'),
        meta: {
            title: '零跑汽车'
        }
    },
    {
        // 转介绍B01换装活动
        path: '/InviteB01Activity.html',
        name: 'InviteB01Activity',
        component: () => import('@/pages/thematic-framework/InviteB01Activity/index.vue'),
        meta: {
            title: '零跑汽车'
        }
    },
    {
        // 抽奖奖品列表
        path: '/rewardList.html',
        name: 'rewardList',
        component: () => import('@/pages/thematic-framework/InviteActivityDay/rewardList.vue'),
        meta: {
            title: '零跑汽车'
        }
    },
    {
        // 邀请进度列表
        path: '/inviteRecord.html',
        name: 'rewardList',
        component: () => import('@/pages/thematic-framework/InviteActivityDay/inviteRecord.vue'),
        meta: {
            title: '零跑汽车'
        }
    }
];
const router = new VueRouter({
    mode: 'history',
    routes
});
router.beforeEach((to, from, next) => {
    document.title = to.meta.title ? to.meta.title : '';
    if (from.path !== '/' && from.path !== to.path) { // 页面切换,H5之间路由跳转
        console.log('router-beforeEach--page');
        window.webBuriedFn && window.webBuriedFn('pageDuration', '页面停留时长'); // 用户埋点统计停留在页面的时长
    }
    next();
});
export default router;
